import request from '../../../helpers/request';

const getFlatAttachment = async (addressId, fileName) => {
  const response = await request.get(
    `/HousingStock/address/${addressId}/attachment`,
    {
      fileName,
    },
    'Не удалось загрузить файл'
  );

  return response;
};

export default getFlatAttachment;
